import { MbcAssessment, MbcAssessmentNames } from 'types/Visit/MeasurementBasedCare'
import TestIds from 'constants/test-ids'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import { useRef } from 'react'
import Modal, { ModalRef } from '@ui-components-3/ui/lib/components/Modal'
import { getMbcLabel } from 'util/getMbcLabel'
import { observer } from 'mobx-react-lite'
import AssessmentDetails from 'components/Dashboard/cards/Visit/common/CollapsedBlock/MeasurementBasedCare/AssessmentDetails'

type MbcScoreCardProps = {
  title: MbcAssessmentNames
  assessment: MbcAssessment
}

const MbcScoreCard = ({ title, assessment }: MbcScoreCardProps) => {
  const assessmentDetailsRef = useRef<ModalRef>(null)

  const MbcLabel = getMbcLabel(title, assessment?.score)

  return (
    <>
      <div
        className="rounded-2xl border border-neutral-300 flex flex-col items-center gap-2 p-4 text-center typography-body-l text-neutral-700"
        data-testid={TestIds.visits.measurementBasedCare.mbcColumn}
      >
        <p className="font-bold">{title} Score</p>
        <p className="font-medium" data-testid={TestIds.visits.measurementBasedCare.mbcColumn.score}>
          {assessment?.score || 0}
        </p>
        <p
          data-testid={TestIds.visits.measurementBasedCare.mbcColumn.label}
          className={classNames('typography-small font-semibold text-white px-3 py-1 rounded-full', MbcLabel.color)}
        >
          {MbcLabel.name}
        </p>
        <button
          type="button"
          onClick={() => assessmentDetailsRef.current?.open()}
          data-testid={TestIds.visits.measurementBasedCare.mbcColumn.button}
          className="text-link-primary"
        >
          View Details
        </button>
      </div>
      <Modal ref={assessmentDetailsRef} label={`${title} Assessment Details`} portal>
        <AssessmentDetails assessment={assessment} />
      </Modal>
    </>
  )
}

export default observer(MbcScoreCard)
